import Breakpoints from '../../_constants/breakpoints';

function getCurrentBreakpoint(viewportWidth) {
    if (viewportWidth > Breakpoints.LG) {
        return Breakpoints.LG;
    }

    if (viewportWidth > Breakpoints.MD) {
        return Breakpoints.MD;
    }

    if (viewportWidth > Breakpoints.SM) {
        return Breakpoints.SM;
    }

    return Breakpoints.XS;
}

export { getCurrentBreakpoint };